const isDatepickerSupport = () => {
  const input = document.createElement("input")
  input.type = "date"
  // Set a invalid value to check if the browser will change it to a valid value
  input.value = "idv"
  const isSupported = input.value !== "idv"
  return isSupported
}

export default isDatepickerSupport